import microuniversoApi from "app/api/microuniversoApi";
import { DadosEnviarEmail, anexosEnviar } from "app/types/modalImprimir/ModalEnviarEmail";
import {
    RespostaModalEnviarEmail,
    RespostaModalImprimir,
    payloadEnviarEmail
} from "app/types/modalImprimir/RespostaModalImprimir";
import { tratamentoErroPadrao } from "app/use-cases";
import globalMU from "globalMU";
import React, { useEffect, useState } from "react";
import { ParametrosTemplate, montarUrl } from "../modalImprimirContainer";
import { ModalEnviarEmail } from "./modalEnviarEmail";
import {Parametro} from "../../../../../types/Parametro";
import { gl } from "date-fns/locale";
//import {obterParametros} from "../../../../../use-cases/parametro/obterParametros";

export type ModalEnviarEmailContainerProps = {
    exibirModalEmail: boolean;
    template: RespostaModalImprimir;
    idOrcamento: number;
    permitidoAnexar: boolean
    permitidoCopia: boolean
    permitidoCopiaOculta: boolean
    permitidoAlterarAssunto: boolean
    permitidoAlterarMensagem: boolean
    parametrosTemplate: ParametrosTemplate[];
    onClose: () => void;
}

export const ModalEnviarEmailContainer = (props: ModalEnviarEmailContainerProps) => {
    const [dadosEnviarEmail, setDadosEnviarEmail] = useState<RespostaModalEnviarEmail>(null);
    const [listaAnexos, setListaAnexos] = useState([]);
    const [urlTemplate, setUrlTemplate] = useState<string>("");
    const [parametros, setParametros] = useState<Parametro[]>([])
    const [processando, setProcessando] = useState(true)
    const [buscandoDadosEmail, setBuscandoDadosEmail] = useState(true);
    const atualizarParametros = async () => {
        try {
            const params = await microuniversoApi.Parametro.obterVarios([
                "EMAIL_ORC_SERVIDOR_SMTP",
                "EMAIL_ORC_ENDERECO_REMETENTE",
            ])
            setParametros(params)
        } catch (e) {
            tratamentoErroPadrao(e)
        }
    }
    const valorParametro = (nome: string) => parametros.find(p => p.Nome == nome)?.Valor
    const buscarDadosEnviarEmail = async (identificadorOrcamento: number) => {
        
        if (!props.exibirModalEmail) 
            return
        let dadosEnviarEmailLocal;
        try {
            try 
            {
                dadosEnviarEmailLocal = await microuniversoApi.Orcamento.ObterInformacoesEnvioEmailClientePorNumero(identificadorOrcamento);
                setDadosEnviarEmail(dadosEnviarEmailLocal);

            }
            catch (erro) {
                tratamentoErroPadrao(erro);

            }

            if(dadosEnviarEmailLocal?.Anexos && dadosEnviarEmailLocal?.Anexos.length > 0 ){
                setUrlTemplate(montarUrl(props.template?.Url, props.parametrosTemplate, dadosEnviarEmailLocal?.Anexos[0]?.UrlDownload))
            }
        }
        catch (erro) {
            tratamentoErroPadrao(erro);
            
        }
        finally {
            setBuscandoDadosEmail(false)
        }
        
        
    }

    const validateEmail = (email: string) => {
        const re = /\S+@\S+\.\S+/;
        return re.test(email);
    }
    
    const EnviarEmail = async (dados: payloadEnviarEmail) => {
        try {
            globalMU.blockUI()
            setProcessando(true)
        if (globalMU.isNull(dados.destinatarioInput) || dados.destinatarioInput === "") {
            globalMU.showErrorMessage("O campo \"Destinatário\" é obrigatório");
            return;
        }

        if (valorParametro("EMAIL_ORC_SERVIDOR_SMTP") === null || valorParametro("EMAIL_ORC_SERVIDOR_SMTP") === "" || valorParametro("EMAIL_ORC_SERVIDOR_SMTP") === "N") {
            globalMU.showWarnMessage("Parâmetro [Envio de Email pelo Orçamento, nome do servidor SMTP] configurado incorretamente")
            return;
        }

        if (valorParametro("EMAIL_ORC_ENDERECO_REMETENTE") === null || valorParametro("EMAIL_ORC_ENDERECO_REMETENTE") === "" || valorParametro("EMAIL_ORC_ENDERECO_REMETENTE") === "N") {
            globalMU.showWarnMessage("Parâmetro [Envio de Email pelo Orçamento, endereço a substituir o cadastrado na forma de comunicação] configurado incorretamente")
            return;
        }

        const emailsCopia = dados.Copia.split(',')
            //console.log(emailsCopia)
            if (emailsCopia.length > 0) {
                for (let email of emailsCopia) {
                    if (!validateEmail(email) && email.length > 0) {
                        globalMU.showErrorMessage(`O campo "Cópia" possui email(s) inválido(s): ${email}`)
                        return;
                    }
                }
            }

        const emailsCopiaOculta = dados.CopiaOculta.split(',')
            //console.log(emailsCopiaOculta)
            if (emailsCopiaOculta.length > 0) {
                for (let email of emailsCopiaOculta) {
                    if (!validateEmail(email) && email.length > 0) {
                        globalMU.showErrorMessage(`O campo "Cópia Oculta" possui email(s) inválido(s): ${email}`)
                        return;
                    }
                }
            }

        if (listaAnexos.length > 0) {
            var formData = new FormData();
            for (let i: number = 0; i < listaAnexos.length; i++) {


                formData.append(
                    "Anexo" + (i + 1),
                    listaAnexos[i],
                    listaAnexos[i].name
                );
            }
            var anexoResponse: anexosEnviar[] = await enviarAnexo(formData);
        }

        const token = globalMU.token();

        let anexos: anexosEnviar[] = dadosEnviarEmail?.Anexos?.map((anexo) => {
            return {
                name: anexo.NomeArquivo,
                url: montarUrl(props.template.Url, props.parametrosTemplate, anexo.UrlDownload),
                anexado: anexo.Anexado,
                NomeArquivo: anexo.NomeArquivo,
                Principal: anexo.Principal,
                UrlDownload: montarUrl(props.template.Url, props.parametrosTemplate, anexo.UrlDownload),
            }
        });

        const payload: DadosEnviarEmail = {
            destinatarios: [dados.destinatarioInput],
            destinatario: dados.destinatarioInput,
            destinatarioInput: dados.destinatarioInput,
            copia: dados.Copia,
            copiaOculta: dados.CopiaOculta,
            listaCopia: emailsCopia,
            listaCopiaOculta: emailsCopiaOculta,
            assunto: dados.Assunto,
            mensagem: dados?.Mensagem,
            remetente: dados.Remetente,
            anexos: globalMU.isNullOrEmpty(anexoResponse)? anexos:anexos.concat(anexoResponse),
            template: props.template,
            token: token,
        };
        globalMU.blockUI()
            await microuniversoApi.Comum.EnviarEmail(payload);
            
            props.onClose()
            globalMU.showSuccessMessage('E-mail enviado com sucesso!')
        }
        catch (erro) {
            
            //tratamentoErroPadrao(erro)
            globalMU.showErrorMessage('Ocorreu um erro ao enviar o e-mail!')
            props.onClose()
        } finally {
            setProcessando(false)
            globalMU.unblockUI()
        }
    }
    const enviarAnexo = async (binario): Promise<anexosEnviar[]> => {
        
        try {
            globalMU.blockUI();
            return await microuniversoApi.Seguranca.enviarAnexos(globalMU.token(), binario)
        }
        catch (erro) {
            tratamentoErroPadrao(erro);
        } finally {
            globalMU.unblockUI()
            
        }
    }
    const AnexarDocumentos = (event) => {
        
        if (event.target.files[0] && event.target.files[0].name) {
            setListaAnexos(current => [...current, event.target.files[0]]);
        }
        
    }
    const RemoverAnexo = (AnexoRemovido, pos) => {
        setListaAnexos((current) => current.filter((anexo, index) => anexo !== AnexoRemovido || index !== pos));
    }
    // useEffect(() => {
    //     if (props.exibirModalEmail) {
    //         buscarDadosEnviarEmail(props.idOrcamento);

    //     }
    // }, [props.exibirModalEmail])
    useEffect(() => {
        const executarFuncoes = async () => {
            globalMU.blockUI()
            setProcessando(true)
            await Promise.all([
                globalMU.blockUI(),
                atualizarParametros(),
                globalMU.blockUI(),
                props.exibirModalEmail && buscarDadosEnviarEmail(props.idOrcamento),
                globalMU.blockUI(),
            ]).finally(() => {
                setProcessando(false)
                globalMU.unblockUI()
            })
        }
        executarFuncoes()
        
    }, [props.exibirModalEmail])
    return (
        <>
            {props.exibirModalEmail && !buscandoDadosEmail &&
                <ModalEnviarEmail
                    processando={processando}
                    RespostaModalEnviarEmail={dadosEnviarEmail}
                    Anexos={listaAnexos}
                    urlTemplate={urlTemplate}
                    PermitidoAnexarEmail={props.permitidoAnexar}
                    PermitidoAlterarAssunto={props.permitidoAlterarAssunto}
                    PermitidoCopiaOculta={props.permitidoCopiaOculta}
                    PermitidoCopia={props.permitidoCopia}
                    PermitidoAlterarMensagem={props.permitidoAlterarMensagem}
                    onClose={props.onClose}
                    onEnviar={EnviarEmail}
                    onAnexar={AnexarDocumentos}
                    onRemoverAnexo={RemoverAnexo}
                />
            }
        </>
    );
}
